// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderPrescriber {
    static getAttributeTypeMap() {
        return PharmacyCardFinderPrescriber.attributeTypeMap;
    }
}
PharmacyCardFinderPrescriber.discriminator = undefined;
PharmacyCardFinderPrescriber.additionalProperties = false;
PharmacyCardFinderPrescriber.attributeTypeMap = [
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "PharmacyCardFinderAddress"
    },
];
//# sourceMappingURL=pharmacyCardFinderPrescriber.js.map